<template>
  <div class="head-line" @click="goDetail">
    <div class="img-wrap">
      <img v-if="content.coverPicture" :src="content.coverPicture" alt="中海头条">
      <img
        v-else
        alt="中海头条"
        src="https://xfjoss.coli688.com/pc-images/headline-palceholder.png"
      />
    </div>
    <div class="content">
      <div class="title">{{ content.title }}</div>
      <!-- <div class="desc" v-html="content.content" ></div> -->
      <div class="content-time">
        <div class="flex-col"></div>
        <div class="time">{{ content.createdAt | timeFilter }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { headLineUrl } from '@/api/config'
export default {
  props: {
    showBorder: {
      type: Boolean,
      default: true
    },
    content: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {

    }
  },
  filters: {
    timeFilter (val) {
      if (!val) return
      const timeArr = val.split('-')
      let str =  `${timeArr[0]}/${timeArr[1]}/${timeArr[2].slice(0,timeArr[2].length-3)}`
      return str
    }
  },
  methods: {
    goDetail () {
      const url = headLineUrl + '1/' + this.content.id
      this.$router.push({ path: `/headLine/detail?headLineUrl=${encodeURI(url)}` })
    },
  }
}
</script>
<style lang="scss" scoped>
.head-line{
  margin-right: 20px;
  margin-bottom: 20px;
  &:nth-child(2n+2) {
    margin-right: 0px;
  }
  display: flex;
  justify-content: flex-start;
  cursor: pointer;
  width: 580px;
  .img-wrap{
    img{
      width: 232px;
      height: 153px;
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
    }
  }
  .content{
    position: relative;
    background-color: rgba(250, 248, 243, 1);
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding-left: 25px;
    width: 100%;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    .title{
      @include font20(500, #3E3E3E);
      padding-top: 20px;
      padding-right: 20px;
      &:hover{
        color: rgba(189, 162, 108, 1);
      }
    }
    // .desc{
    //   @include font14(400, #9399A5);
    //   margin-top: 16px;
    // }
    .content-time {
      display: flex;
      position: absolute;
      bottom: 22px;
      .time{
      @include font14(400, #BDA26C);
      }
      .flex-col {
        width: 18px;
        height: 18px;
        background: url(https://xfjoss.coli688.com/pc-images/time-icon.png) -1px -1px
          no-repeat;
        background-size: 18px 18px;
        margin-right: 5px;
        margin-top: 1px;
      }
    }
   
  }
}
// .border-bottom{
//   border-bottom: 1px solid #E6E6E6;
// }
</style>
